import React from "react";
import {
  TableCell,
  TableRow,
  Tooltip,
  Typography, 
  makeStyles,
  withStyles
} from "@material-ui/core";
import { TEXT_SECONDARY_COLOR } from "../../../theme";

export default function LinhaTabelaLaboratorio({ laboratorio, handleClickLinha, codigoSelecionado  }) {
  const classes = useStyles();

  return (
    <TableRow key={laboratorio.id}  className={`${classes.linhaTabela} ${codigoSelecionado === laboratorio.codigo ? classes.selected : ''}`}
    onClick={() => handleClickLinha(laboratorio.codigo)}>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '90px', maxWidth: '90px'}}>
        <TooltipStyles
          title={laboratorio?.codigo}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
            {laboratorio?.codigo}
          </Typography>
        </TooltipStyles>
      </TableCell>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '150px', maxWidth: '150px'}}>
        <TooltipStyles
          title={laboratorio?.nome}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
            {laboratorio?.nome}
          </Typography>
        </TooltipStyles>
      </TableCell>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '110px', maxWidth: '110px'}}>
        <TooltipStyles
          title={laboratorio?.cidade}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
            {laboratorio?.cidade}
          </Typography>
        </TooltipStyles>
      </TableCell>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '80px', maxWidth: '80px'}}>
      <TooltipStyles
          title={laboratorio?.situacao}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
            {laboratorio?.situacao}
          </Typography>
        </TooltipStyles>
      </TableCell>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '150px', maxWidth: '150px'}}>
      <TooltipStyles
          title={laboratorio?.responsavel}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
          {laboratorio?.responsavel}
          </Typography>
        </TooltipStyles>
      </TableCell>
      <TableCell className={classes.celulaTabela} style={{ minWidth: '130px', maxWidth: '130px'}}>
      <TooltipStyles
          title={laboratorio?.cnpj}
          placement="bottom-start"
        >
          <Typography noWrap className={classes.larguraTexto}>
          {laboratorio?.cnpj}
          </Typography>
        </TooltipStyles>
      </TableCell>
    </TableRow>
  );
}

const TooltipStyles = withStyles((theme) => ({
	tooltip: {
		border: "1px solid #C0C0DE",
		borderRadius: "4px",
		backgroundColor: "#333333",
		boxShadow: "0 5px 10px 0 rgba(192, 192, 222, 0.43)",
		color: " #FFFFFF",
		fontFamily: "CircularStd-Book",
		fontSize: "12px",
	},
}))(Tooltip)

const useStyles = makeStyles((theme) => ({
  linhaTabela: {
    width: "100%",
    '&:hover': {
      backgroundColor: "#C0C0DE66",
      color: TEXT_SECONDARY_COLOR,
      cursor: 'pointer'
    },
    backgroundColor: "#FAFAFA",
    height: '31px'
  },
  selected: {
    backgroundColor: "rgba(50, 49, 114, 0.17)",
  },
  celulaTabela: {
    padding: "4px 8px 4px 16px",
    height: "32px",
    color: TEXT_SECONDARY_COLOR,
    borderBottom: '1px solid #F3F3F3'
  },
  larguraTexto: {
    fontSize: '12px'
  }
}));
